import { render, staticRenderFns } from "./CheckMobile.vue?vue&type=template&id=89d70e7c&scoped=true&"
import script from "./CheckMobile.vue?vue&type=script&lang=js&"
export * from "./CheckMobile.vue?vue&type=script&lang=js&"
import style0 from "./CheckMobile.vue?vue&type=style&index=0&id=89d70e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d70e7c",
  null
  
)

export default component.exports